import router from '../router';

const routerUtils = {
    moveTo(route) {
        router.push({ path: `${route}` })
    }
}
export default routerUtils;
